import React from "react";

// To inject a build date, we can use an environment variable at build time.
// Suppose REACT_APP_BUILD_DATE is set during your build process.
// Fallback to current date if not set.
const getLastUpdated = () => {
  const buildDate =
    process.env.REACT_APP_BUILD_DATE ||
    new Date().toISOString().split("T")[0]; // Fallback to ISO yyyy-mm-dd

  const dateObj = new Date(buildDate);
  // Format as "Month Year" (e.g., "February 2026")
  return dateObj.toLocaleString("en-US", { month: "long", year: "numeric" });
};

const Footer = () => {
  return (
    <footer className="p-4 shadow-md bg-lightBg dark:bg-darkBg">
      <div className="text-sm container text-center text-lightText dark:text-darkText">
        <p>
          &copy; {new Date().getFullYear()} Kellie Sim • Last Updated: {getLastUpdated()}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
